import { render, staticRenderFns } from "./SomaSummary.vue?vue&type=template&id=ecb5541e"
import script from "./SomaSummary.vue?vue&type=script&lang=js"
export * from "./SomaSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports